
<template>
  <v-row>
    <v-col md="12">
      <v-row>
        <v-col md="4" class="pt-0 pb-0" v-for="test in testTypeData" :key="test.value">
          <v-checkbox v-model="testTypes" :label="test.label" :value="test.value" class="mt-0"></v-checkbox>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { TestTypes } from '@/components/test-types/data/test-types.js';

export default {
  props: ['defaultSelection'],
  data() {
    return {
      testTypes: [],
      testTypeData: new TestTypes()
    };
  },
  watch: {
    testTypes(n) {
      if (n) {
        this.$emit('testTypeSelected', n);
      }
    }
  },
  created() {
    if (this.defaultSelection) {
      this.testTypes.push(this.defaultSelection);
    }
  }
};
</script>

<style>
</style>